import EntityGroupList from '@/pages/entityGroup/EntityGroupList.vue'
import EntityGroupDetails from '@/pages/entityGroup/EntityGroupDetails.vue'

export default [
  {
    path: '/entityGroup/',
    component: EntityGroupList,
    props: true
  },
  {
    path: '/entityGroup/:mode/:id',
    component: EntityGroupDetails,
    props: true
  }
]
